/**
 * Checks if a target is a non-null object with the property specified,
 * strictly matching a value, if provided.
 */
export function hasProperty<P extends string | number | symbol>(
  target: unknown,
  property: P,
): target is { [K in P]: { [key in K]: unknown } }[P];
export function hasProperty<P extends string | number | symbol, const V>(
  target: unknown,
  property: P,
  value: V,
): target is { [K in P]: { [key in K]: V } }[P];
export function hasProperty<P extends string | number | symbol, const V>(target: unknown, property: P, value?: V) {
  return (
    typeof target === 'object' &&
    target !== null &&
    property in target &&
    (value === undefined || (target as { [K in P]: unknown })[property] === value)
  );
}
